import { render, staticRenderFns } from "./PaidOrder.vue?vue&type=template&id=5d2caf37&scoped=true"
import script from "./PaidOrder.vue?vue&type=script&lang=js"
export * from "./PaidOrder.vue?vue&type=script&lang=js"
import style0 from "./PaidOrder.vue?vue&type=style&index=0&id=5d2caf37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2caf37",
  null
  
)

export default component.exports